var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"audioRemote"}),_c('audio',{ref:"audioLocal"})])
}
var staticRenderFns = []

export { render, staticRenderFns }